import React, { Component } from "react";
import { get } from "lodash";
import KnowledgeListItem from "./KnowledgeListItem";
import styled from "styled-components";
import { ActivityIndicator } from "antd-mobile";

import { getPatientIdFromUrl } from "../../../utils";

export default class Correlation extends Component {
  getCorrelationArticle(list) {
    if (list.length > 0 && !list[0].recordId) {
      list.sort((m, n) => {
        if (n.views === m.views) {
          if (n.comments === m.comments) {
            return n.sharings - m.sharings;
          } else {
            return n.comments - m.comments;
          }
        } else {
          return n.views - m.views;
        }
      });
      while (list.length > 3) {
        list.pop();
      }
    }
    return list;
  }
  render() {
    const patientId = getPatientIdFromUrl(this.props);
    const fontSize = get(this.props, "match.params.fontSize"); // 文章字号

    if (this.props.correlationBlogs && !this.props.correlationBlogs.loading) {
      const getBlogRecommend = this.getCorrelationArticle([
        ...this.props.correlationBlogs.getBlogRecommend,
      ]); // 相关推荐

      return (
        <div
          style={{
            padding: "0 14px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TitleText>相关推荐</TitleText>
          <Line />
          {getBlogRecommend.map((e, currentIndex) => (
            <div>
              <KnowledgeListItem
                item={e}
                patientId={patientId}
                fontSize={fontSize}
                knowledgeId={e._id}
                len={getBlogRecommend.length}
                currentIndex={currentIndex}
                {...this.props}
              />
            </div>
          ))}
        </div>
      );
    } else {
      return <ActivityIndicator toast text="加载中" />;
    }
  }
}

const TitleText = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333;
  line-height: 20px;
  display: flex;
  align-items: center;
  padding: 14px 0 10px;
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;
`;

const Line = styled.div`
  width: 100vw;
  height: 1px;
  background: rgba(245, 246, 248, 1);
`;
const Lines = styled.div`
  width: 100vh;
  height: 10px;
  background: #f5f6f8;
`;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/correlation.js